// @flow
import React from "react";
import { Map } from "immutable";
import type { GazelleData, GazelleObject } from "../../types/gazelle.js";
import { findRef } from "../../utils/gazelle.js";
import "./InlineImage.scss";

const BASE_URL = "/media/files/";

export default function InlineImage(props: {
  gazelleData: GazelleData,
  inlineImageData: GazelleObject
}) {
  const imageData = findRef(
    props.gazelleData,
    props.inlineImageData.getIn(["attributes", "image"], Map())
  );
  if (imageData == null) {
    return null;
  }

  return (
    <img
      className="gazelle-preview__inline-image"
      src={`${BASE_URL}${imageData.getIn(["attributes", "path"], "")}`}
    />
  );
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/gazelle/InlineImage.js